<template>
    <div class="app-container">
        <CriteriaTitle005 />
        <CriteriaCard012 />
    </div>
</template>

<script setup>
import CriteriaTitle005 from './CriteriaTitle005.vue'
import CriteriaCard012 from './CriteriaCard012.vue'
</script>

<style scoped>
.app-container {
    /* padding-top: 20px; */
    background: #fff9f1;
}
</style>